export function relativeToStatic(url, staticUrl){
    return decodeURI(url).replace(staticUrl,'').replace(/%23/g, "#");
};
 
 
 // [https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid]
export function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      ((c ^ crypto.getRandomValues(new Uint8Array(1))[0]) & (15 >> c / 4)).toString(16)
    );
}
  
  // [https://stackoverflow.com/questions/2998784/how-to-output-numbers-with-leading-zeros-in-javascript]
export function pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
  }

  /* Utility function to convert a canvas to a BLOB */
export function dataURLToBlob(dataURL){
    var BASE64_MARKER = ';base64,';
    if (dataURL.indexOf(BASE64_MARKER) === -1) {
        let parts = dataURL.split(',');
        let contentType = parts[0].split(':')[1];
        let raw = parts[1];

        return new Blob([raw], {type: contentType});
    }

    let parts = dataURL.split(BASE64_MARKER);
    let contentType = parts[0].split(':')[1];
    let raw = window.atob(parts[1]);
    var rawLength = raw.length;

    var uInt8Array = new Uint8Array(rawLength);

    for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], {type: contentType});
  }
  /* End Utility function to convert a canvas to a BLOB      */


export function b64toBlob(b64Data, contentType='', sliceSize=512){
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
}

  // https://stackoverflow.com/questions/922057/is-it-possible-to-preview-local-images-before-uploading-them-via-a-form
export function createObjectURL(object) {
    return (window.URL) ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object);
  }

export function revokeObjectURL(url) {
    return (window.URL) ? window.URL.revokeObjectURL(url) : window.webkitURL.revokeObjectURL(url);
  }

export function myUploadOnChangeFunction() {
    if(this.files.length) {
        for(var i in this.files) {
            var src = createObjectURL(this.files[i]);
            var image = new Image();
            image.src = src;
            // Do whatever you want with your image, it's just like any other image
            // but it displays directly from the user machine, not the server!
        }
    }
  }

  // https://dmitripavlutin.com/how-to-compare-objects-in-javascript/
export function shallowEqual(object1, object2) {
    if(!object1 || !object2)return false;
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (let key of keys1) {
      if (object1[key] !== object2[key]) {
        return false;
      }
    }
    return true;
  }

export function trimFloat(f, l){
    l = l?parseInt(`1${'0'.repeat(l)}`):100;
    return Math.round(f*l)/l;
  }

  // https://stackoverflow.com/questions/14234560/javascript-how-to-get-parent-element-by-selector
export function closest(el, selector, stopSelector) {
    var retval = null;
    while (el) {
        if (el.matches(selector)) {
        retval = el;
        break
        } else if (stopSelector && el.matches(stopSelector)) {
        break
        }
        el = el.parentElement;
    }
    return retval;
  }

  // https://stackoverflow.com/questions/7526849/how-do-i-change-a-filename-on-download-with-javascript
export function downloadAs(url, name){
        var xhr = new XMLHttpRequest(),
            a = document.createElement('a'), file;

        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
            file = new Blob([xhr.response], { type : 'application/octet-stream' });
            a.href = window.URL.createObjectURL(file);
            a.download = name;  // Set to whatever file name you want
            // Now just click the link you created
            // Note that you may have to append the a element to the body somewhere
            // for this to work in Firefox
            a.click();
        };
        xhr.send();
    }


  // https://stackoverflow.com/questions/27936772/how-to-deep-merge-instead-of-shallow-merge
  // deep merge
export function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
  }

  // [TO CHECK]
  // [note] arrays are not cloned
export function deepClone(obj) {
    // if (typeof obj !== "object" || obj === null) {
    if(!obj || (obj.constructor !== Object && obj.constructor !== Array)){
        return obj;
    }

    if(obj.constructor === Array){
        return obj.map(itm=>deepClone(itm));
    }

    let clone = {};
    for (let key in obj) {
      clone[key] = deepClone(obj[key]);
    }

    return clone;
  }

export function mergeDeeps(){
    return deepClone(mergeDeepsNotClone(...arguments));
  }

export function mergeDeep(target, source, useSelf) {
    return deepClone(mergeDeepNotClone(target, source, useSelf));
  }

  // [note] clone at the final step
export function mergeDeepsNotClone(){
    let args = [...arguments];
    let output = mergeDeepNotClone({}, args[0]);
    for(let i=1; i<args.length; i++){
        output = mergeDeepNotClone(output, args[i]);
    }

    return deepClone(output);
  }

export function mergeDeepNotClone(target, source, useSelf) {
    let output = useSelf?target:Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (isObject(source[key])) {
                if (!(key in target))
                    Object.assign(output, { [key]: source[key] });
                else
                    output[key] = mergeDeepNotClone(target[key], source[key]);
            } else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    return output;
  }


  // [note] not clone version
export function _mergeDeeps(){
    let args = [...arguments];
    let output = mergeDeep({}, args[0]);
    for(let i=1; i<args.length; i++){
        output = mergeDeep(output, args[i]);
    }

    return output;
  }

  // [note] not clone version
export function _mergeDeep(target, source, useSelf) {
    let output = useSelf?target:Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (isObject(source[key])) {
                if (!(key in target))
                    Object.assign(output, { [key]: source[key] });
                else
                    output[key] = mergeDeep(target[key], source[key]);
            } else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    return output;
  }
  // https://stackoverflow.com/questions/8817394/javascript-get-deep-value-from-object-by-passing-path-to-it-as-string
export function deep_value(obj, pathIn, seperator){
    for (var i=0, path=pathIn.split(seperator || '.'), len=path.length; i<len; i++){
        obj = obj[path[i]];
    };
    return obj;
  };

export function flipObj(obj){
    let out={};
    Object.keys(obj).forEach(fld=>{
        out[obj[fld]]=fld;
    });

    return out;
  }

  // https://stackoverflow.com/questions/38768724/create-an-object-based-on-file-path-string
export function pathsToObj(pathsIn, seperator){
    let dir = {};
    pathsIn.forEach(p=>{
        let paths=p.split(seperator || ',');
        paths.reduce(
            function(dir, path){
            return dir[path] = dir[path]||{};
            },
            dir
        )
    });

    return dir;
  }

  // https://stackoverflow.com/questions/5137831/map-a-range-of-values-e-g-0-255-to-a-range-of-colours-e-g-rainbow-red-b
export function rainbow(n) {
    n = n * 240 / 255;
    return 'hsl(' + n + ',100%,50%)';
  }

export function RainBowColor(length, maxLength)
  {
    var i = (length * 255 / maxLength);
    var r = Math.round(Math.sin(0.024 * i + 0) * 127 + 128);
    var g = Math.round(Math.sin(0.024 * i + 2) * 127 + 128);
    var b = Math.round(Math.sin(0.024 * i + 4) * 127 + 128);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }




// utilities end

export function regObj(tblEntry, tblDef, tblDef2){
    window.tblDef = tblDef2 || tblDef;
    return tblDef;
};

export function getDate(){
    return (new Date()).toISOString().split('T')[0];
};

export function getDateFn(){
    return getDate;
    // return _=>(new Date()).toISOString().split('T')[0];
};

export function getObjId(arrObj){
    return false;
};

export function getObjOptById(){

};

export const lans={};

export function getLan(str){
    return (this.lans[this.curLan || 'en']||{})[str] || (this.lans['en']||{})[str] || str;
};

export const arrUnits=[
    ['PC', 'piece'],
    ['DZ', 'dozen'],
];

export const arrCurrencies=[
    ['CAD', 'CAD'],
    ['USD', 'USD'],
];

export function fldFor(){

};

export function forIdShowFn(){
return "";
};

export function getStaticUrl(){
return "";
};

export const arrEdit={
stdShowActionBtn: _=>""
};

export const tbls={
getTblId: _=>""
};

export async function uploadImages(imgs){
    return Promise.all(Array.prototype.map.call(imgs, imgItemCon=>{
        let img = imgItemCon.querySelector('img');
        let imageItemId = img.getAttribute('image-item-id');
        let fldName = img.getAttribute('fld-name');
                                    // let newImage = img.getAttribute('new');
        if(img.src.substr(0,5)==='data:'){
            // upload
            let data = new FormData();
            data.append("file_data", b64toBlob(img.src.split(',')[1]))
            data.append("file_name", img.getAttribute('file-name') || `file-${uuidv4()}`);
            let upload_url = "/html/upload/test"

            return fetch(
                upload_url, 
                {
                    "method": "POST",
                    "body": data,
                }
            )
            .then(r=>r.json())
            .then(data=>({
                url: data.fileUrl,
                imageItemId,
                
                fldName
            }));
        }else{
            // [note] image already uploaded, so fld data should be url relative to static (url got from img.src is the full url)
            return {
                url: relativeToStatic(img.src, ""),
                imageItemId,
                fldName
            };
        }
    }));

};

export async function uploadFiles(files){
    return Promise.all(Array.prototype.map.call(files, fileItemCon=>{
        let a = fileItemCon.querySelector('a');
        let fileItemId = a.getAttribute('file-item-id');
        let fldName = a.getAttribute('fld-name');
        if(a.href.substr(0,5)==='data:'){
            // upload
            let data = new FormData();

            let fileName = a.innerText;
            data.append("file_data", b64toBlob(a.href.split(',')[1]))
            data.append("file_name", fileName || `file-${uuidv4()}`);
            let upload_url = "/html/upload/test"
            return fetch(
                upload_url, 
                {
                    "method": "POST",
                    "body": data,
                }
            )
            .then(r=>r.json())
            .then(data=>({
                url: data.fileUrl,
                // fileName,
                fileItemId,
                fldName: fldName
            }));
        }else{
            return {
                // [note] file already uploaded, so fld data should be url relative to static (url got from img.src is the full url)
                url: relativeToStatic(a.href, ""),
                // fileName,
                fileItemId,
                fldName: fldName
            }
        }
    }));
};

export const countries = {
    "CN":"China",
    "CA":"Canada",
    "BD":"Bangladesh",
    "AC":"Ascension Island",
    "AD":"Andorra",
    "AE":"United Arab Emirates",
    "AF":"Afghanistan",
    "AG":"Antigua And Barbuda",
    "AI":"Anguilla",
    "AL":"Albania",
    "AM":"Armenia",
    "AN":"Netherlands Antilles",
    "AO":"Angola",
    "AQ":"Antarctica",
    "AR":"Argentina",
    "AS":"American Samoa",
    "AT":"Austria",
    "AU":"Australia",
    "AW":"Aruba",
    "AX":"Åland",
    "AZ":"Azerbaijan",
    "BA":"Bosnia And Herzegovina",
    "BB":"Barbados",
    "BE":"Belgium",
    "BF":"Burkina Faso",
    "BG":"Bulgaria",
    "BH":"Bahrain",
    "BI":"Burundi",
    "BJ":"Benin",
    "BM":"Bermuda",
    "BN":"Brunei Darussalam",
    "BO":"Bolivia",
    "BR":"Brazil",
    "BS":"Bahamas",
    "BT":"Bhutan",
    "BV":"Bouvet Island",
    "BW":"Botswana",
    "BY":"Belarus",
    "BZ":"Belize",
    "CC":"Cocos (Keeling) Islands",
    "CD":"Congo (Democratic Republic)",
    "CF":"Central African Republic",
    "CG":"Congo (Republic)",
    "CH":"Switzerland",
    "CI":"Cote D’Ivoire",
    "CK":"Cook Islands",
    "CL":"Chile",
    "CM":"Cameroon",
    "CO":"Colombia",
    "CR":"Costa Rica",
    "CU":"Cuba",
    "CV":"Cape Verde",
    "CX":"Christmas Island",
    "CY":"Cyprus",
    "CZ":"Czech Republic",
    "DE":"Germany",
    "DJ":"Djibouti",
    "DK":"Denmark",
    "DM":"Dominica",
    "DO":"Dominican Republic",
    "DZ":"Algeria",
    "EC":"Ecuador",
    "EE":"Estonia",
    "EG":"Egypt",
    "ER":"Eritrea",
    "ES":"Spain",
    "ET":"Ethiopia",
    "EU":"European Union",
    "FI":"Finland",
    "FJ":"Fiji",
    "FK":"Falkland Islands (Malvinas)",
    "FM":"Micronesia, Federated States Of",
    "FO":"Faroe Islands",
    "FR":"France",
    "GA":"Gabon",
    "GD":"Grenada",
    "GE":"Georgia",
    "GF":"French Guiana",
    "GG":"Guernsey",
    "GH":"Ghana",
    "GI":"Gibraltar",
    "GL":"Greenland",
    "GM":"Gambia",
    "GN":"Guinea",
    "GP":"Guadeloupe",
    "GQ":"Equatorial Guinea",
    "GR":"Greece",
    "GS":"South Georgia And The South Sandwich Islands",
    "GT":"Guatemala",
    "GU":"Guam",
    "GW":"Guinea-Bissau",
    "GY":"Guyana",
    "HK":"Hong Kong",
    "HM":"Heard And Mc Donald Islands",
    "HN":"Honduras",
    "HR":"Croatia (local name: Hrvatska)",
    "HT":"Haiti",
    "HU":"Hungary",
    "ID":"Indonesia",
    "IE":"Ireland",
    "IL":"Israel",
    "IM":"Isle of Man",
    "IN":"India",
    "IO":"British Indian Ocean Territory",
    "IQ":"Iraq",
    "IR":"Iran (Islamic Republic Of)",
    "IS":"Iceland",
    "IT":"Italy",
    "JE":"Jersey",
    "JM":"Jamaica",
    "JO":"Jordan",
    "JP":"Japan",
    "KE":"Kenya",
    "KG":"Kyrgyzstan",
    "KH":"Cambodia",
    "KI":"Kiribati",
    "KM":"Comoros",
    "KN":"Saint Kitts And Nevis",
    "KR":"Korea, Republic Of",
    "KW":"Kuwait",
    "KY":"Cayman Islands",
    "KZ":"Kazakhstan",
    "LA":"Lao People’s Democratic Republic",
    "LB":"Lebanon",
    "LC":"Saint Lucia",
    "LI":"Liechtenstein",
    "LK":"Sri Lanka",
    "LR":"Liberia",
    "LS":"Lesotho",
    "LT":"Lithuania",
    "LU":"Luxembourg",
    "LV":"Latvia",
    "LY":"Libyan Arab Jamahiriya",
    "MA":"Morocco",
    "MC":"Monaco",
    "MD":"Moldova, Republic Of",
    "ME":"Montenegro",
    "MG":"Madagascar",
    "MH":"Marshall Islands",
    "MK":"Macedonia, The Former Yugoslav Republic Of",
    "ML":"Mali",
    "MM":"Myanmar",
    "MN":"Mongolia",
    "MO":"Macau",
    "MP":"Northern Mariana Islands",
    "MQ":"Martinique",
    "MR":"Mauritania",
    "MS":"Montserrat",
    "MT":"Malta",
    "MU":"Mauritius",
    "MV":"Maldives",
    "MW":"Malawi",
    "MX":"Mexico",
    "MY":"Malaysia",
    "MZ":"Mozambique",
    "NA":"Namibia",
    "NC":"New Caledonia",
    "NE":"Niger",
    "NF":"Norfolk Island",
    "NG":"Nigeria",
    "NI":"Nicaragua",
    "NL":"Netherlands",
    "NO":"Norway",
    "NP":"Nepal",
    "NR":"Nauru",
    "NU":"Niue",
    "NZ":"New Zealand",
    "OM":"Oman",
    "PA":"Panama",
    "PE":"Peru",
    "PF":"French Polynesia",
    "PG":"Papua New Guinea",
    "PH":"Philippines, Republic of the",
    "PK":"Pakistan",
    "PL":"Poland",
    "PM":"St. Pierre And Miquelon",
    "PN":"Pitcairn",
    "PR":"Puerto Rico",
    "PS":"Palestine",
    "PT":"Portugal",
    "PW":"Palau",
    "PY":"Paraguay",
    "QA":"Qatar",
    "RE":"Reunion",
    "RO":"Romania",
    "RS":"Serbia",
    "RU":"Russian Federation",
    "RW":"Rwanda",
    "SA":"Saudi Arabia",
    "GB-SCT":"Scotland",
    "SB":"Solomon Islands",
    "SC":"Seychelles",
    "SD":"Sudan",
    "SE":"Sweden",
    "SG":"Singapore",
    "SH":"St. Helena",
    "SI":"Slovenia",
    "SJ":"Svalbard And Jan Mayen Islands",
    "SK":"Slovakia (Slovak Republic)",
    "SL":"Sierra Leone",
    "SM":"San Marino",
    "SN":"Senegal",
    "SO":"Somalia",
    "SR":"Suriname",
    "ST":"Sao Tome And Principe",
    "SU":"Soviet Union",
    "SV":"El Salvador",
    "SY":"Syrian Arab Republic",
    "SZ":"Swaziland",
    "TC":"Turks And Caicos Islands",
    "TD":"Chad",
    "TF":"French Southern Territories",
    "TG":"Togo",
    "TH":"Thailand",
    "TJ":"Tajikistan",
    "TK":"Tokelau",
    "TI":"East Timor (new code)",
    "TM":"Turkmenistan",
    "TN":"Tunisia",
    "TO":"Tonga",
    "TP":"East Timor (old code)",
    "TR":"Turkey",
    "TT":"Trinidad And Tobago",
    "TV":"Tuvalu",
    "TZ":"Tanzania, United Republic Of",
    "UA":"Ukraine",
    "UG":"Uganda",
    "UK":"United Kingdom",
    "UM":"United States Minor Outlying Islands",
    "US":"United States",
    "UY":"Uruguay",
    "UZ":"Uzbekistan",
    "VA":"Vatican City State (Holy See)",
    "VC":"Saint Vincent And The Grenadines",
    "VE":"Venezuela",
    "VG":"Virgin Islands (British)",
    "VI":"Virgin Islands (U.S.)",
    "VN":"Vietnam",
    "VU":"Vanuatu",
    "WF":"Wallis And Futuna Islands",
    "WS":"Samoa",
    "YE":"Yemen",
    "YT":"Mayotte",
    "ZA":"South Africa",
    "ZM":"Zambia",
    "ZW":"Zimbabwe"
}